export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14447.eff893a2.jpg";